<template>
  <div class="icon-box">
    <Icon class="icon icon--42" />
    <span class="icon-text t-hero-s">{{ t(`hero.${icon}`) }}</span>
  </div>
</template>

<script setup lang="ts">
import type { IconsEnum } from '@/service/__generated-api'

const props = defineProps<{ icon: IconsEnum }>()
const Icon = defineAsyncComponent(
  () => import(`@/assets/icons/hero/${props.icon}.svg?component`)
)

const { t } = useI18n()
</script>

<style scoped lang="scss">
.icon-box {
  @include flex-col;
  position: relative;
  gap: rem(8px);
  align-items: center;
  padding-inline: rem(8px);
  text-align: center;

  &::before {
    --out-of-border: #{rem(-3px)};

    position: absolute;
    inset: var(--out-of-border) auto var(--out-of-border) 0;
    width: rem(1px);
    content: '';
    background-color: $layout-divider;

    @include media-up(lg) {
      --out-of-border: #{rem(-11.5px)};
    }
  }

  &:nth-child(3n + 1) {
    @include media-up(md) {
      &:not(:first-child)::before {
        display: block;
      }
    }

    &::before {
      display: none;
    }
  }

  .icon {
    color: $global-sun-01;
  }
}
</style>
